import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import convoStore from '../convo-store'
import setConvoQuery from './set-convo-query'

export default async function addSearchTag(context: BareActionContext<ConvoState, RootState>)
{
  const form = convoStore.state.convoSearchForm
  if (form.tags.indexOf(form.tag) < 0) {
    form.tags.push(form.tag)
  }
  form.tag = ''
  setConvoQuery(context)

  return
}
